import { render } from "./StoreTable.vue?vue&type=template&id=5ca754c4"
import script from "./StoreTable.vue?vue&type=script&lang=js"
export * from "./StoreTable.vue?vue&type=script&lang=js"

import "./StoreTable.vue?vue&type=style&index=0&id=5ca754c4&lang=css"

import exportComponent from "/Users/perthpiti/InsightEra/ENOLA/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__